// state
import axios from "axios";
import commonservice from "../../../shared/common.service";

const defaultState = () => ({
  entity: {
    id: null,
    contentId: null,
    attachment: null,
    name: null
  }
});

const state = defaultState();
// getters
const getters = {};

// actions
const actions = {
  loadContentAttachment({ state }, { pagination, search }) {
    return new Promise((resolve, reject) => {
      var param = {
        descending:
          pagination.sortDesc.length > 0 ? pagination.sortDesc[0] : false,
        page: pagination.page,
        rowsPerPage: pagination.itemsPerPage,
        sortBy: pagination.sortBy.length > 0 ? pagination.sortBy[0] : "name",
        search: search,
        contentId: state.entity.contentId
      };
      axios
        .get("/contentattachment?" + commonservice.convertToQueryString(param))
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  setContentAttachment({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/contentattachment/" + id)
        .then(response => {
          commit("SET_CONTENT_ATTACHMENT", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  save({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.entity.id) {
        axios
          .patch("/contentattachment", state.entity)
          .then(
            response => {
              commit("RESET");
              resolve(response);
            },
            error => {
              reject(error);
            }
          )
          .catch(error => {
            reject(error);
          });
      } else {
        axios
          .post("/contentattachment", state.entity)
          .then(
            response => {
              commit("RESET");
              resolve(response);
            },
            error => {
              reject(error);
            }
          )
          .catch(error => {
            reject(error);
          });
      }
    });
  },
  deleteContentAttachment({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .delete("/contentattachment/" + id)
        .then(response => {
          commit("RESET");
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

// mutations
const mutations = {
  RESET(state) {
    const contentId = state.entity.contentId;
    Object.assign(state, defaultState());
    state.entity.contentId = contentId;
  },
  SET_CONTENT_ATTACHMENT_DATA(state, data) {
    if (Object.prototype.toString.call(state[data.key]) === "[object Array]") {
      state[data.key][data.index][data.property] = data.value;
    } else if (
      Object.prototype.toString.call(state[data.key]) === "[object Object]"
    ) {
      state[data.key][data.property] = data.value;
    } else state.entity[data.key] = data.value;
  },
  SET_CONTENT_ATTACHMENT(state, data) {
    state.entity.id = data.id;
    state.entity.name = data.name;
    state.entity.attachment = data.attachment;
    state.entity.contentId = data.contentId;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
